// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2627c59","453":"011bb5d4","455":"e5f10734"}[chunkId] + ".chunk.js";
};